import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, selectCurrentUserRole } from '../store/slices/authSlice';

export default function NotFound() {
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const userRole = useSelector(selectCurrentUserRole);
    document.title = 'Varosa - 404';

    const handleBackBtn = () => {
        if (isAuthenticated && userRole) {
            navigate('/dashboard/'+userRole);
        } else {
            navigate('/');
        }
    };

    return (
        <div className="container-fluid py-5 login-container">
            <div className="container">
                <div className="row g-5">
                    <div className="col-12 mb-4 text-center">
                        <div className="bg-light rounded p-4">
                            <h2 className="mb-0">404 Not Found</h2>
                        </div>
                        <button
                            onClick={handleBackBtn}
                            className="btn btn-light mt-3"
                        >
                            back to home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}